import { Component, OnInit, ElementRef, AfterViewInit, OnDestroy, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GameService } from '../../services/game.service';
import { Level, Game, LevelElement } from '../../_models/model';
import { AudioPlayerService } from '../../services/audio-player.service';
import { GameComponent } from '../../games/game/game.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-level-dashboard',
  templateUrl: './level-dashboard.component.html',
  styleUrls: ['./level-dashboard.component.less']
})
export class LevelDashboardComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @HostListener('window:keydown.y', ['$event'])
  onKeyPress(keycode: KeyboardEvent) {

  }

  public appVersion = environment.version;
  public activeLevel: Level | null = null;
  public activeGame: Game | null = null;
  public svgImage: any;
  public showGame: boolean = false;
  public showLiedje: boolean = true;
  public bottomNotification: string = '';
  public showBottomNotification: boolean = false;
  public hideBackButton = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private elRef: ElementRef,
    private gameService: GameService,
    public audio: AudioPlayerService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    throw new Error('Method not implemented.');
  }

  ngOnDestroy(): void {
    this.svgImage = null;
  }

  roadmapLoaded(svgImage: SVGElement) {
    svgImage.outerHTML = svgImage.outerHTML;
    this.activeLevel?.levelElements.forEach((levelElement, index) => {
      const pinActive = this.elRef.nativeElement.querySelector('g[data-name="btn_' + (index + 1) + '_active"]');
      const pinDone = this.elRef.nativeElement.querySelector('g[data-name="btn_' + (index + 1) + '_done"]');
      const pinInactive = this.elRef.nativeElement.querySelector('g[data-name="btn_' + (index + 1) + '_inactive"]');
      if (!pinActive) {
        console.error('pinActive ' + (index + 1) + ' not found');
      }
      if (!pinDone) {
        console.error('pinDone ' + (index + 1) + ' not found');
      }
      if (!pinInactive) {
        console.error('pinDone ' + (index + 1) + ' not found');
      }
      if (pinActive) {
        pinActive.classList.add('pinButton');
        pinActive.addEventListener('click', () => this.selectGameStep(levelElement));
      }
      if (pinDone) {
        pinDone.classList.add('pinButton');
        pinDone.addEventListener('click', () => this.selectGameStep(levelElement));
      }
      // pinInactive.classList.add('pinButton');


    });
    // for (const pin of this.elRef.nativeElement.querySelectorAll('.pin')) {
    //     pin.addEventListener('click', this.selectGame.bind(this));
    // }
    this.updateMap();
  }

  updateMap() {
    // TODO: should get current gameid!
    if (!this.activeLevel?.order) {
      return;
    }
    const activeLevel = this.activeLevel;
    const currentStep = this.gameService.getCurrentStep(this.activeLevel.order);
    // console.log({ activeLevel, currentStep });
    // After loading the SVG map, register all click events
    //


    this.activeLevel.levelElements.forEach((levelElement, index) => {
      const stepNr = index + 1;
      const completed = this.gameService.getGameCompletedStatus(activeLevel.order, stepNr);
      let state: 'active' | 'done' | 'inactive' = completed ? 'done' : 'inactive';
      if (stepNr === currentStep) {
        state = 'active';
      }
      if (stepNr < currentStep && !completed) {
        state = 'active';
      }
      this.setState(stepNr, state);
    });

    // for (const pin of this.elRef.nativeElement.querySelectorAll('.pin')) {
    //     const stepNr = +pin.getAttribute('x-data');  // 1 tm 8
    //     const completed = this.gameService.getGameCompletedStatus(this.activeLevel.order, stepNr);
    //     if (completed === true) {
    //         pin.classList.add('completed');
    //         // pin.classList.add('done');
    //     }

    //     // This hacky delay is neccessary because the update map is loaded after OnInit and fails the transform effects.
    //     if (stepNr === currentStep) {
    //         setTimeout(() => {
    //             pin.classList.add('current');
    //         }, 16);
    //     } else {
    //         pin.classList.remove('current');
    //     }
    // }

    // for (const road of this.elRef.nativeElement.querySelectorAll('.route-part')) {
    //     const gameNr = +road.getAttribute('x-data');
    //     const completed = this.gameService.getGameCompletedStatus(this.activeLevel.order, gameNr);
    //     if (completed === true) {
    //         road.classList.add('completed');
    //     }
    // }

  }

  private setState(stepNr: number, state: 'active' | 'done' | 'inactive') {
    const pinActive = this.elRef.nativeElement.querySelector('g[data-name="btn_' + (stepNr) + '_active"]');
    const pinDone = this.elRef.nativeElement.querySelector('g[data-name="btn_' + (stepNr) + '_done"]');
    const pinInactive = this.elRef.nativeElement.querySelector('g[data-name="btn_' + (stepNr) + '_inactive"]');
    if (pinActive) {
      pinActive.style.display = state === 'active' ? 'block' : 'none';
    }
    if (pinInactive) {
      pinInactive.style.display = state === 'inactive' ? 'block' : 'none';
    }
    if (pinDone) {
      pinDone.style.display = state === 'done' ? 'block' : 'none';
    }
  }

  // Debug functions to cycle through levels.
  // roadmapLoaded(step: any = null) {
  //     for (const pin of this.elRef.nativeElement.querySelectorAll('.pin')) {
  //         pin.addEventListener('click', this.selectGame.bind(this));
  //     }
  //     console.log('mike', step.data);
  //     this.updateMap(step);
  // }

  // updateMap(step: any = null) {
  //     let currentStep;
  //     currentStep = step.data;

  //     // currentStep = this.gameService.getCurrentStep(this.activeLevel.order);

  //     if (!currentStep) {
  //         return;
  //     }


  //     // After loading the SVG map, register all click events
  //     for (const pin of this.elRef.nativeElement.querySelectorAll('.pin')) {
  //         const stepNr = +pin.getAttribute('x-data');  // 1 tm 8
  //         let completed: boolean; // = this.gameService.getGameCompletedStatus(this.activeLevel.order, stepNr);
  //         if (currentStep > stepNr) {
  //             completed = true;
  //         } else {
  //             completed = false;
  //         }
  //         if (completed === true) {
  //             pin.classList.add('completed');
  //             // pin.classList.add('done');
  //         } else {
  //             pin.classList.remove('completed');

  //         }
  //         console.log('mike stepNr', stepNr);
  //         console.log('mike currentStep', currentStep);
  //         if (stepNr == currentStep) {
  //                 pin.classList.add('current');
  //         } else {
  //             pin.classList.remove('current');
  //         }

  //     }
  //     for (const road of this.elRef.nativeElement.querySelectorAll('.route-part')) {
  //         const gameNr = +road.getAttribute('x-data');
  //         //const completed2 = this.gameService.getGameCompletedStatus(this.activeLevel.order, gameNr);
  //         if (currentStep > gameNr) {
  //             road.classList.add('completed');
  //         } else {
  //             road.classList.remove('completed');
  //         }
  //     }
  // }

  playText() {
    this.audio.getPlay('level_dashboard_footer');
  }

  ngOnInit() {
    this.activeLevel = this.gameService.getLevel(+this.route.snapshot.params.id);
    if (this.activeLevel.order > 0) {
      this.svgImage = '/img/levels/level_' + this.activeLevel.order + '/roadmap_' + this.activeLevel.order + '.svg';
    } else {
      this.svgImage = null;
    }

    if (this.activeLevel.order > 0) {
      this.bottomNotification = this.audio.getPlay('level_dashboard_footer');
      this.showBottomNotification = true;
    } else {
      this.showBottomNotification = false;
    }


    // if refreshed from /level/x/(game:x) activate game shown mode
    if (this.route.children.find(x => x.outlet === 'game')) {
      this.activateGameShownMode();
    }

    // Direct show game 1 in level 0
    // console.log({activeLevel: this.activeLevel})
    if (this.activeLevel.order === 0) {
      const firstStep = this.activeLevel.levelElements.find(l => l.step === 1);
      if (!firstStep) {
        throw Error('no first step in level 0');
      }
      this.selectGameStep(firstStep);
      // this.showLiedje = false;
      // this.router.navigate([{ outlets: { 'game': [1] } }], { relativeTo: this.route })
      // .then(routingIsAllowed => {
      //   if (routingIsAllowed) {
      //     this.showLiedje = false;
      //     this.activateGameShownMode();
      //   }
      // });
    } else {
      this.showLiedje = true;
    }
  }

  ngAfterViewInit(): void {
    if (window.hasOwnProperty('resizeJijEnik')) {
      (window as any)['resizejijEnik'].call();
    }
  }

  selectGameStep(gameStep: LevelElement) {
    this.audio.playSoundClick();
    const gameId = gameStep.step;
    // Guard protects this route if not open!
    // skipLocationChange should be true since calling /level/x/(game:y) directly creates problems because
    // the levelGuard is called before the levelResolver which creates a problem when the user tries to
    // refresh the page.
    // console.log('select game for route');
    if (this.activeLevel === undefined || this.activeLevel === null) {
      throw Error('no active level')
    }
    this.activeGame = this.gameService.getGame(this.activeLevel.order, gameId)
    this.router.navigate([{ outlets: { 'game': [gameId] } }], { relativeTo: this.route })
      .then(routingIsAllowed => {
        if (routingIsAllowed) {
          // console.log('show active');
          this.activateGameShownMode();
        }
      });
  }

  selectGame(event: Event) {
    this.audio.playSoundClick();

    const closest = (event.target as HTMLDivElement).closest('.pin')?.getAttribute('x-data');
    const gameId = closest ? +closest : undefined;
    if (this.activeLevel === undefined || this.activeLevel === null) {
      throw Error('no active level')
    }
    if (gameId === undefined) {
      return;
    }


    // Guard protects this route if not open!
    // skipLocationChange should be true since calling /level/x/(game:y) directly creates problems because
    // the levelGuard is called before the levelResolver which creates a problem when the user tries to
    // refresh the page.
    this.router.navigate([{ outlets: { 'game': [gameId] } }], { relativeTo: this.route })
      .then(routingIsAllowed => {
        if (routingIsAllowed) {
          this.activateGameShownMode();

        }
      });
  }

  private activateGameShownMode() {
    this.showGame = true;
    this.showBottomNotification = false;
    this.showLiedje = this.activeGame?.type !== 'GameVideo';
  }

  onCloseGame() {
    this.showGame = false;
    this.activeGame = null;
    this.showBottomNotification = true;
    this.updateMap();
    this.hideBackButton = false;
    this.showLiedje = true;
  }

  onActivate(componentRef: GameComponent): void {
    componentRef.onClose.subscribe(x => {
      this.onCloseGame();
    });
    componentRef.hideBackButton.subscribe(x => {
      this.hideBackButton = true;
    });
  }

  btnBackClick() {
    this.audio.cancelAll();
    if (this.showGame && (this.activeLevel?.order || 0) > 0) {
      this.showGame = false;
      this.activeGame = null;
      this.showBottomNotification = true;
      this.updateMap();
      this.router.navigate(['.', { outlets: { game: null } }], { relativeTo: this.route });
      this.showLiedje = true;
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
}
